import React, {useEffect, useState} from 'react';
import {useLazyQuery} from '@apollo/client';
import {query} from '../../services/queries/queries';
import {TacticI} from '../../interfaces/general';

interface SelectorI {
	selected: string[]
	setSelected : (s:string[]) => void
}

export default function TacticSelector({selected, setSelected}:SelectorI) {

	const [loading, setLoading] = useState<boolean>(true);

	const [queryTactics, { data }] = useLazyQuery(query("tacticsFindMany"));

	useEffect(()=>{
		if(loading){
			queryTactics({
				variables: {
					filter: {
						active: true
					}
				},
				fetchPolicy: 'no-cache',
				onCompleted: (data:any):void => setLoading(false)
			});
		}
	},[loading]);

	return (
		<div>
			<select value={selected && selected?.length > 0 ? selected[0] : ''} onChange={(e)=>setSelected([e.target.value])}>
				<option value={''}>Select one...</option>
				{data && data?.tacticFindMany?.length > 0 && data?.tacticFindMany?.map(({_id, title}:TacticI)=>{
					return (
						<option key={_id} value={_id}>
							{title}
						</option>
					)
				})}
			</select>

		</div>
	)
}
